import { createReducer } from '@reduxjs/toolkit';
import {
	getDeviceStatus,
	getDeviceStatusRejected,
	getDeviceStatusResolved,
	restoreStatusStore,
	resampleAllSensors,
	resampleSensor,
	resampleSensorJob,
	resampleSensorJobRejected,
	resampleSensorJobResolved,
} from '@Actions';
import { DeviceStatus, SensorDetailsStoreState } from '@Types';

export const initialState: SensorDetailsStoreState = {
	status: 'idle',
	initialized: false,
	deviceStatus: DeviceStatus.Unknown,
	resampleJob: {
		initialized: false,
		status: 'idle',
	},
};

const reducer = createReducer(initialState, builder =>
	builder
		.addCase(getDeviceStatus, state => {
			state.initialized = false;
			state.status = 'pending';
		})
		.addCase(resampleSensor, state => {
			state.initialized = false;
			state.status = 'pending';
		})
		.addCase(resampleSensorJob, state => {
			state.initialized = false;
			state.status = 'pending';
			state.resampleJob.initialized = false;
			state.resampleJob.status = 'pending';
		})
		.addCase(resampleSensorJobResolved, state => {
			state.initialized = true;
			state.status = 'completed';
			state.resampleJob.initialized = true;
			state.resampleJob.status = 'completed';
		})
		.addCase(resampleSensorJobRejected, state => {
			state.initialized = false;
			state.status = 'rejected';
			state.resampleJob.initialized = true;
			state.resampleJob.status = 'rejected';
		})
		.addCase(resampleAllSensors, state => {
			state.initialized = false;
			state.status = 'pending';
		})
		.addCase(getDeviceStatusResolved, (state, { payload }) => {
			state.initialized = true;
			state.status = 'completed';
			state.deviceStatus = payload;
		})
		.addCase(getDeviceStatusRejected, state => {
			state.initialized = true;
			state.status = 'rejected';
			state.deviceStatus = DeviceStatus.Unavailable;
		})
		.addCase(restoreStatusStore, () => initialState),
);

export default reducer;
